<ng-container *ngIf="sectionForm | async as sectionForm; else loading">
  <div class="d-flex justify-content-center">
    <app-header></app-header>
    <div class="d-flex flex-column feedback-container w-100">
      <form [formGroup]="feedbackForm">
        <ng-container *ngIf="sections | async as sections">
          <ng-container *ngFor="let section of sections">
            <section [id]="'section-' + section.currentSection" *ngIf="section.isActive">
              <h2 class="mx-3">{{section.currentSection | labelSection }}</h2>
              <ng-container *ngFor="let form of sectionForm[section.currentSection]; let i=index;">
                <div class="gap my-3" *ngIf="i > 0 && section.currentSection != 'customer'"></div>
                <ng-container [ngSwitch]="form.type">
                  <ng-template [ngSwitchCase]="'input'">
                    <div class="form-item">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                      <mat-form-field appearance="outline" class="w-100 pt-2" [formArrayName]="form.formControlName">
                        <input matInput
                               [id]="form.formControlName"
                               [type]="form.dataType == 'int' ? 'number' : 'text'"
                               [placeholder]="form.placeholder"
                               autocomplete="off"
                               formControlName="value">
                      </mat-form-field>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'email'">
                    <div class="form-item">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Masukkan email yang valid</mat-error>
                      <mat-form-field appearance="outline" class="w-100 pt-2" [formArrayName]="form.formControlName">
                        <input matInput
                               [id]="form.formControlName"
                               [placeholder]="form.placeholder"
                               type="email"
                               autocomplete="off"
                               formControlName="value">
                      </mat-form-field>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'phone'">
                    <div class="form-item">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Masukkan nomor ponsel yang valid</mat-error>
                      <mat-form-field appearance="outline" class="w-100 pt-2" [formArrayName]="form.formControlName">
                        <input matInput
                               [id]="form.formControlName"
                               [placeholder]="form.placeholder"
                               type="tel"
                               mask='000-000-0000-0000'
                               autocomplete="off"
                               formControlName="value">
                      </mat-form-field>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'text'">
                    <div class="form-item">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                      <mat-form-field appearance="outline" class="w-100 pt-2" [formArrayName]="form.formControlName">
                      <textarea matInput
                                [id]="form.formControlName"
                                [type]="form.dataType == 'int' ? 'number' : 'text'"
                                [placeholder]="form.placeholder"
                                autocomplete="off"
                                formControlName="value"></textarea>
                      </mat-form-field>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'date'">
                    <div class="form-item">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                      <mat-form-field appearance="outline" class="w-100 pt-2" [formArrayName]="form.formControlName">
                        <input matInput
                               [id]="form.formControlName"
                               [matDatepicker]="dp"
                               placeholder="DD/MMM/YYYY"
                               autocomplete="off"
                               formControlName="value">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp
                                        startView="multi-year"
                                        panelClass="example-month-picker">
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'star'">
                    <div class="form-item" [formArrayName]="form.formControlName" [id]="form.formControlName">
                      <shared-star-rating
                        [isOpenNotes]="stateOpenRatingForm == form.formControlName"
                        [id]="form.formControlName"
                        [label]="form.label"
                        [placeholder]="form.placeholder"
                        [config]="{
                        isRequired: form.isRequired,
                        initialValue: +getInitialValue(form.formControlName),
                        initialOtherValue: getInitialOtherValue(form.formControlName),
                        withOtherValue: true,
                        isRequiredOtherValue: false
                      }"
                        (value)="onChangeValue($event, form.formControlName)"
                        (otherValue)="onChangeOtherValue($event, form.formControlName)">
                      </shared-star-rating>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'sales_menu'">
                    <div class="form-item" [formArrayName]="form.formControlName" [id]="form.formControlName">
                      <shared-menu-rating
                        [isOpenNotes]="stateOpenRatingForm == form.formControlName"
                        [companyCode]="companyCode"
                        [label]="form.label"
                        [placeholder]="form.placeholder"
                        [image]="form.image"
                        [config]="{
                          isRequired: form.isRequired,
                          initialValue: +getInitialValue(form.formControlName),
                          initialOtherValue: getInitialOtherValue(form.formControlName),
                          initialImages: getInitialImages(form.formControlName),
                          withOtherValue: true,
                          isRequiredOtherValue: false
                        }"
                        (value)="onChangeValue($event, form.formControlName)"
                        (otherValue)="onChangeOtherValue($event, form.formControlName)"
                        (images)="onChangeImages($event, form.formControlName)">
                      </shared-menu-rating>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'radio'">
                    <div class="form-item my-3">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                      <shared-radio-button
                        [id]="form.formControlName"
                        [items]="form.items"
                        [label]="form.label"
                        [placeholder]="form.placeholder"
                        [config]="{
                          isRequired: form.isRequired,
                          initialValue: getInitialValue(form.formControlName),
                          initialOtherValue: getInitialOtherValue(form.formControlName),
                          withOtherValue: true,
                          isRequiredOtherValue: false
                         }"
                        (value)="onChangeValue($event, form.formControlName)"
                        (otherValue)="onChangeOtherValue($event, form.formControlName)">
                      </shared-radio-button>
                    </div>

                  </ng-template>

                  <ng-template [ngSwitchCase]="'checkbox'">
                    <div class="form-item">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName)">Form wajib diisi.</mat-error>
                      <section class="d-flex flex-column" [id]="form.formControlName"
                               [formArrayName]="form.formControlName">
                        <ng-container *ngFor="let item of form.items; let i = index" [formArrayName]="'value'">
                          <mat-checkbox color="primary" [formControlName]="item.id" [value]="item.value">
                            {{item.label}}
                          </mat-checkbox>
                          <ng-container *ngIf="item.isAllowOtherValue && getIsSelected(form.formControlName, item.id)">
                            <mat-form-field appearance="outline" class="w-100 py-2">
                              <input matInput formControlName="otherValue" [placeholder]="form.placeholder">
                            </mat-form-field>
                          </ng-container>
                        </ng-container>
                      </section>
                    </div>
                  </ng-template>

                  <ng-template [ngSwitchCase]="'dropdown'">
                    <div class="form-item">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                      <section
                        class="d-flex flex-column"
                        [id]="form.formControlName"
                        [formArrayName]="form.formControlName">
                        <mat-form-field appearance="outline" class="w-100 pt-2">
                          <mat-select
                            (selectionChange)="onChangeValue($event.value, form.formControlName)"
                            [value]="getInitialValue(form.formControlName)"
                            [placeholder]="form.placeholder">
                            <ng-container *ngFor="let item of form.items; let i = index">
                              <mat-option [formArrayName]="'value'" [value]="item.value">{{item.label}}</mat-option>
                            </ng-container>
                          </mat-select>
                        </mat-form-field>
                        <ng-container
                          *ngIf="isShowOtherValue(form.formControlName, form.items)">
                          <mat-form-field appearance="outline" class="w-100 py-2">
                            <input matInput formControlName="otherValue" [placeholder]="form.placeholder">
                          </mat-form-field>
                        </ng-container>
                      </section>
                    </div>
                  </ng-template>
                  <ng-template [ngSwitchCase]="'image'">
                    <div class="form-item mt-3">
                      <label class="label">{{form.label}} <span class="text-danger" *ngIf="form.isRequired">*</span></label>
                      <mat-error *ngIf="validationError(form.formControlName.toString())">Form wajib diisi.</mat-error>
                      <button
                        *ngIf="!getInitialValue(form.formControlName); else  uploadedImage"
                        mat-flat-button
                        class="d-flex flex-row btn-base my-3"
                        type="button"
                        (click)="openUploadDialog(form.formControlName, 'upload')">
                        <mat-icon class="pointer" style="min-width: 24px;">add</mat-icon>
                        Tambah Foto
                      </button>
                      <ng-template #uploadedImage>
                        <div class="pointer image-preview my-2"
                             (click)="openUploadDialog(form.formControlName, 'update')">
                          <img
                            [ngSrc]="imageTmpEndpoint + getInitialValue(form.formControlName)"
                            class="img-fluid"
                            fill="contain"
                            [alt]="form.formControlName"/>
                        </div>
                      </ng-template>
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>
              <div class="footer">
                <ng-container *ngIf="section.nextSection != null; else submitButton">
                  <button mat-flat-button class="d-flex flex-row btn-base btn-next" type="button"
                          (click)="onNextStep(sectionForm, section)">Berikutnya
                  </button>
                </ng-container>
                <ng-template #submitButton>
                  <button mat-flat-button class="d-flex flex-row btn-base btn-next" type="submit" (click)="onSubmit(sectionForm, section)">Kirim</button>
                </ng-template>
              </div>

            </section>

          </ng-container>


        </ng-container>

      </form>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="d-flex align-items-center justify-content-center h-100 w-100">
    <div class="loader"></div>
  </div>
</ng-template>
